import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Rotas } from 'src/app/core/rotas';
import { FiltroAtividade } from '../../core/filtro/filtro-atividade';
import { PlanejamentoOficina } from '../../core/planejamento-oficina';
import { BaseService } from '../base/base.service';

@Injectable({
  providedIn: 'root'
})
export class PlanejamentoOficinaService extends BaseService<PlanejamentoOficina> {
    
    

    constructor(http: HttpClient) {
      super(http, Rotas.OFICINA_TURMAS);
    }

    getAllByArea(area: string) {
      const params: any = {};
      if (area) params.area = area;
      return this.http.get(Rotas.OFICINA_TURMAS, {params});
    }

    aprovar(id: number) {
      return this.http.put(Rotas.OFICINA_TURMAS + id.toString() + "/aprovar", null);
    }

    getByFilter(filtro: FiltroAtividade) {
        const params: any = {};

        if (filtro.descricao) params.descricao = filtro.descricao;
        if (filtro.projeto) params.projeto = filtro.projeto.id;
        if (filtro.dataInicio) params.dataInicio = filtro.dataInicio.getTime();
        if (filtro.dataFim) params.dataFim = filtro.dataFim.getTime();
        if (filtro.area) params.area = filtro.area;
        return this.http.get(Rotas.OFICINA_TURMAS + "filter", {params});
    }
}
